// extracted by mini-css-extract-plugin
module.exports = {"formContrl":"formContrl--3LQVV","description":"description--2MGqM","markstaUpload":"markstaUpload--1Z2Hn","switch":"switch--CQziv"};